import React from 'react';
import { Link } from 'react-router-dom';
import './AboutPage.css';

/**
 * About page component
 */
function AboutPage() {
  return (
    <div className="about-page">
      <div className="about-header">
        <h1>About AI Code Implementer</h1>
        <p className="about-subtitle">
          A powerful tool for implementing code with AI assistance
        </p>
      </div>
      
      <div className="about-section">
        <h2>Our Mission</h2>
        <p>
          AI Code Implementer was built to streamline software development by leveraging the power of AI coding assistants
          while maintaining complete privacy and security of your code. Our mission is to help developers implement their
          ideas faster and more efficiently without compromising on quality or privacy.
        </p>
      </div>
      
      <div className="about-section">
        <h2>How It Works</h2>
        <div className="phases-grid">
          <div className="phase-card">
            <div className="phase-number">1</div>
            <h3>Planning</h3>
            <p>Define your project requirements and let AI break them down into components, files, and implementation sequence.</p>
          </div>
          
          <div className="phase-card">
            <div className="phase-number">2</div>
            <h3>Design</h3>
            <p>Create detailed technical specifications and organize files into implementation batches based on dependencies.</p>
          </div>
          
          <div className="phase-card">
            <div className="phase-number">3</div>
            <h3>Coding</h3>
            <p>Implement code files in batches based on the technical design, using AI assistance to generate correct implementations.</p>
          </div>
          
          <div className="phase-card">
            <div className="phase-number">4</div>
            <h3>Refinement</h3>
            <p>Make targeted improvements to specific files, addressing bugs, performance issues, or adding new features.</p>
          </div>
          
          <div className="phase-card">
            <div className="phase-number">5</div>
            <h3>Finishing</h3>
            <p>Verify the implementation, apply performance optimizations, and finalize the project for delivery.</p>
          </div>
        </div>
      </div>
      
      <div className="about-section">
        <h2>Key Features</h2>
        <ul className="features-list">
          <li>
            <strong>100% Private</strong>
            <p>All project data stays in your browser. Nothing is sent to our servers.</p>
          </li>
          <li>
            <strong>AI Optimized</strong>
            <p>Structured prompts maximize the effectiveness of AI coding assistants.</p>
          </li>
          <li>
            <strong>Phased Approach</strong>
            <p>Follow a structured development process from planning to completion.</p>
          </li>
          <li>
            <strong>Multi-Platform</strong>
            <p>Create web, mobile, desktop, and backend applications with ease.</p>
          </li>
          <li>
            <strong>Version Control</strong>
            <p>Track changes to your files with built-in versioning and diff view.</p>
          </li>
          <li>
            <strong>Export & Import</strong>
            <p>Save your projects and share them between devices.</p>
          </li>
        </ul>
      </div>
      
      <div className="about-section">
        <h2>Privacy & Security</h2>
        <p>
          Your privacy is our top priority. AI Code Implementer is designed to work entirely client-side,
          which means all your project data stays in your browser's local storage (IndexedDB).
          No project data is ever sent to our servers, giving you complete control and privacy.
        </p>
        <p>
          For added security and portability, you can export your projects at any time and import them
          on other devices. This ensures you never lose your work and can continue development anywhere.
        </p>
      </div>
      
      <div className="about-section">
        <h2>Get Started</h2>
        <p>
          Ready to build your next project with AI assistance? Start for free today and experience
          a more efficient way to implement your ideas.
        </p>
        <div className="about-actions">
          <Link to="/" className="start-button">
            Create a Project
          </Link>
          <Link to="/premium" className="premium-button">
            Learn About Premium
          </Link>
        </div>
      </div>
      
      <div className="about-footer">
        <p>
          &copy; {new Date().getFullYear()} AI Code Implementer. All rights reserved.
        </p>
        <div className="footer-links">
          <Link to="/privacy">Privacy Policy</Link>
          <Link to="/terms">Terms of Service</Link>
          <Link to="/contact">Contact Us</Link>
        </div>
      </div>
    </div>
  );
}

export default AboutPage;